/**
 * HipCareContextPage — /org/health-info/publish (M2, ABDM HIP)
 *
 * A slim header, then the list (redesign v2):
 *   A. Title (no "(M2)" here - the dashboard card keeps it, OR-70) + subtitle, and HipAbdmMenu: a
 *      "Connected to ABDM" / "Not connected" chip that opens the registration panel + SendAbhaLinkSms.
 *      The panel stays mounted inside the closed menu, so it fetches once and opening adds no request.
 *   B. HipRecordsList — one merged list of completed OPD visits and discharged IPD admissions.
 *      It is self-loading: it owns the date range, filters, search, pager and the single
 *      GET /hip/records fetch, so this page makes no list request of its own.
 * The whole page sits behind AbdmEnabledGate (ABDM off = notice, no records request).
 */
import React, { useState } from 'react';

import AdminPageHeader from '../components/common/AdminPageHeader';
import HipAbdmMenu from '../components/hip/HipAbdmMenu';
import HipRecordsList from '../components/hip/records/HipRecordsList';
import { useTheme } from '../theme/ThemeContext';
import { ABDM_ICONS, LINK_COPY } from '../constants/abdmCopy';
import { LIST } from '../constants/hipRecordsCopy';
import AbdmEnabledGate from '../components/common/AbdmEnabledGate';

function HipCareContextPageBody() {
  const { isDark } = useTheme();

  const [mode, setMode] = useState(null);

  // DISABLED never gets here (AbdmEnabledGate shows the notice); delegated HIP hides the list.
  const disabledForMode = mode && mode !== 'MANAGED_HIP';

  const textMuted = isDark ? '#9ca3af' : '#6b7280';
  const bg = isDark
    ? 'linear-gradient(135deg, #0E0E0F 0%, #1a1a2e 50%, #0E0E0F 100%)'
    : 'linear-gradient(135deg, #f8fafc 0%, #eef2ff 50%, #f8fafc 100%)';

  return (
    <div style={{ minHeight: '100vh', background: bg }}>
      <AdminPageHeader />

      <main style={{ maxWidth: 900, margin: '0 auto', padding: '24px 16px' }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap', marginBottom: 16 }}>
          <div>
            <h1 style={{ fontSize: 24, fontWeight: 700, color: isDark ? '#f5f5f7' : '#111827', margin: 0 }}>
              {ABDM_ICONS.LINK_RECORDS} {LIST.pageTitle}
            </h1>
            <p style={{ fontSize: 14, color: textMuted, marginTop: 4 }}>{LIST.subtitle}</p>
          </div>
          <HipAbdmMenu onModeResolved={setMode} />
        </div>

        {disabledForMode ? (
          <div style={{ textAlign: 'center', padding: '2rem 1rem', color: textMuted }}>
            <p style={{ fontSize: 13 }}>{LINK_COPY.modeNote}</p>
          </div>
        ) : (
          <HipRecordsList />
        )}
      </main>
    </div>
  );
}

export default function HipCareContextPage() {
  return (
    <AbdmEnabledGate>
      <HipCareContextPageBody />
    </AbdmEnabledGate>
  );
}
